"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseSchema = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z
    .object({
    data: zod_1.z.object({ blockId: zod_1.z.number(), insectId: zod_1.z.number(), biofix: zod_1.z.string() }).array().min(1),
    propertyId: zod_1.z.number(),
})
    .refine(({ data }) => data.every((row) => row.insectId === data[0].insectId), {
    message: 'All biofix entries must be for the same insect.',
    path: ['validation'],
});
exports.responseSchema = zod_1.z
    .boolean()
    .or(zod_1.z.object({
    error: zod_1.z.string(),
}))
    .nullable();
//# sourceMappingURL=insectBiofixCreate.js.map